import { render, staticRenderFns } from "./UserMangerEditTabAccount.vue?vue&type=template&id=4dcc70de&"
import script from "./UserMangerEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./UserMangerEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserMangerEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports